import HighlightedComboboxOption from './HighlightedComboboxOption';

export default HighlightedComboboxOption;
